import styled from 'styled-components';

export const PhoneInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
